import colors from "~constants/colors"

const InfiniteLoader = () => (
  <div
    style={{
      position: "absolute",
      bottom: "0",
      display: "flex",
      flex: 1,
      justifyContent: "center",
      width: "100%",
      background: colors.gray2,
    }}
  >
    <b>loading ...</b>
  </div>
)

export default InfiniteLoader
